export const GET_CATEGORIES = "GET_CATEGORIES";
